export { default, default as Icon } from './Icon'
